import dynamic from 'next/dynamic';
import J1 from '../teaser/components/J1';
import Z1 from '../teaser/components/Z1';
import Z1_AU from '../teaser/components/Z1_AU';
import A from './components/A';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const Dynamic = dynamic(() => import('./indexDynamic'), { ssr: true });
const DynamicEU = dynamic(() => import('../teaser/indexDynamicEU'), { ssr: true });
const DynamicAU = dynamic(() => import('../teaser/indexDynamicAU'), { ssr: true });
const DynamicJP = dynamic(() => import('../jp/index'), { ssr: true });
export default function Detail({ needEmail }: any) {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();

    return (
        <div className={`delta-2-max-detail ${css.delta2MaxDetail}`}>
            {['us', 'ca', 'tw', 'br', 'mx'].includes(locale) && (
                <>
                    <A />
                    <Dynamic />
                </>
            )}
            {['eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'cn', 'za', 'sa', 'ph'].includes(locale) && (
                <>
                    {['cn'].includes(locale) && <J1 stage={needEmail ? 'crowdfunding' : 'detail'} />}
                    {!['jp', 'cn'].includes(locale) && <Z1 stage={'detail'} />}
                    {['jp'].includes(locale) ? <DynamicJP /> : <DynamicEU stage={'detail'} />}
                </>
            )}
            {/* 澳洲版本 */}
            {['au'].includes(locale) && (
                <>
                    <Z1_AU stage={'detail'} />
                    <DynamicAU stage={'detail'} />
                </>
            )}
        </div>
    );
}
